import React, { useContext, useEffect, useRef, useState } from 'react';
import { useMediaQuery } from 'react-responsive'
import { useHistory, useRouteMatch } from 'react-router-dom';
import { useDrag } from 'react-use-gesture'

import BuilderContext from '../builder/hooks/context';
import Markup from '../markup';
import { device } from '../const/device';
import { Loader } from './Global/Loader';
import MemberList from "./Global/MemberList";

function Builder() {
  const canvasEl = useRef<HTMLDivElement>(null);
  const { builder, setCanvas } = useContext(BuilderContext);
  const history = useHistory();

  const isMobile = useMediaQuery({ query: `(${device.tablet})` });
  const [isActiveRotateBtn, changeRotateBtnState] = useState(true);

  const bindSwipe = useDrag(({ down, movement: [mx], distance, direction: [xDir, yDir], velocity }) => {
    const trigger = velocity > 0.2;
    const dir = xDir > 0 ? -1 : 1;
    
    if (!down && trigger && !builder?.animationState && !builder.activeLayer() && !builder.hasRecentLayerInteraction?.()) {
      if((yDir >= 0 && yDir < 0.8) || (yDir <= 0 && yDir > -0.8)){
        let nextIndex = builder?.currentCameraIndex + dir;
        const cameraListArr = Object.keys(builder?.cameraList);
        if(dir > 0 && builder?.currentCameraIndex === cameraListArr.length -1) nextIndex = 0;
        if(dir < 0 && builder?.currentCameraIndex === 0) nextIndex = cameraListArr.length -1;
        if (cameraListArr.length > nextIndex && nextIndex >= 0) {
          builder?.setAnimationState(true);
          builder?.setCamera(cameraListArr[nextIndex], true, dir);
        }
      }
    }
  });

  const isTeamPage = useRouteMatch('/name/');
  const isTeamColorPage = useRouteMatch('/color/text');
  const isMobileSubmit = useRouteMatch('/submit/:tabIndex?');
  const colorPage = useRouteMatch<{ id: string }>('/color/layer/:id');

  useEffect(() => {
    setCanvas(canvasEl);
  }, []);


  const pushColor = (id) => {
    if(~history.location.pathname.search("/color/layer/")) history.goBack();
    history.push(`/color/layer/${id}`)
  }

  const onRotateCamera = () => {
    if(!builder?.animationState){
      builder?.rotateCamera();
      builder?.setAnimationState(true);
    }
  }

  const onChangeCamera= (item) => {
    if(!builder?.animationState){
      builder?.setAnimationState(true);
      builder?.setCamera(item);
    }
  }



  return <>
    <Markup.Builder.Builder>
      {isTeamPage || isTeamColorPage || isMobileSubmit ?
        <MemberList/>
      :
        <Markup.BaseLayout.ColorContainer>
          {Array.from(builder?.modelData?.colorList ?? []).map(([id, color]) => (
            <Markup.Global.ColorPicker.Item
              key={builder.modelData.pattern + id}
              color={color}
              active={colorPage?.params?.id === id}
              onClick={() => pushColor(id)}
              themeColor={builder.membersData.colorTheme}
            />)
          )}
        </Markup.BaseLayout.ColorContainer>
      }

      <Markup.Builder.CameraContainer>
        {Object.keys(builder?.cameraList ?? {})
          .map((item, i) => <Markup.Builder.CameraItem active={i === builder?.currentCameraIndex} key={item} onClick={() => onChangeCamera(item)} />)}
          <Markup.Builder.CameraPlayItem onClick={onRotateCamera} />
      </Markup.Builder.CameraContainer>
      <Loader active={!builder?.isReady} prc={builder?.progress} />
      <Markup.Builder.CanvasWrap ref={canvasEl} {...(isMobile ? bindSwipe() : null)} />
    </Markup.Builder.Builder>
  </>;
}


export default React.memo(Builder);
